var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExpressFastOrdersCreateAdmin',{attrs:{"EFO":_vm.EFO},on:{"saveExpressFastOrders":_vm.saveExpressFastOrders}})
}
var staticRenderFns = []

export { render, staticRenderFns }